import { useState, useEffect } from 'react';
import logo from '@/assets/centrolegno-arreda-logo-dark.png';

interface SplashScreenProps {
  onComplete: () => void;
  minDuration?: number;
}

const SplashScreen = ({ onComplete, minDuration = 1200 }: SplashScreenProps) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFading(true);
      setTimeout(() => {
        setIsVisible(false);
        onComplete();
      }, 400);
    }, minDuration);

    return () => clearTimeout(timer);
  }, [minDuration, onComplete]);

  if (!isVisible) return null;

  // Replica esatta del layout della welcome (Login) così il logo resta nella
  // stessa posizione: gli altri elementi sono invisibili ma occupano lo spazio.
  return (
    <div
      className={`fixed inset-0 z-[9999] bg-white flex flex-col transition-opacity duration-400 ${
        isFading ? 'opacity-0' : 'opacity-100'
      }`}
      style={{
        paddingTop: 'calc(var(--safe-area-top, env(safe-area-inset-top, 0px)) + 14px)',
        paddingBottom: 'calc(var(--safe-area-bottom, env(safe-area-inset-bottom, 0px)) + 16px)',
      }}
    >
      <div className="px-4 shrink-0 h-10" />

      <div className="flex-1 flex flex-col items-center justify-center px-8 text-center">
        <img src={logo} alt="Centrolegno Arreda" className="w-80 h-auto mb-8" />
        <p className="text-[15.5px] text-[#6A6661] leading-relaxed max-w-sm invisible">
          Registrati o effettua il login per usufruire di tutti i vantaggi del nostro{' '}
          <span className="font-semibold text-[#111]">Programma Fedeltà</span>.
        </p>
      </div>

      <div className="px-5 shrink-0 invisible" aria-hidden="true">
        <span className="block text-center text-[15px] font-semibold mb-4">Vai alle Informazioni legali</span>
        <div className="w-full h-[56px] rounded-full" />
      </div>
    </div>
  );
};

export default SplashScreen;
